<template>
  <div class="row" id="control-panel">
    <!-- <pre>{{ setup }}</pre> -->
    <div
      v-for="(values, index) in computedSetup"
      :class="values.class"
      :key="index"
      v-show="values.visibility === undefined ? true : values.visibility"
    >
      <!-- <div v-if="values.visibility === undefined ? true : values.visibility"> -->

      <!-- THIS IS NOT CURRENTLY NEEDED AS IF THERE IS NO NHMIS THE NUM/DENOM IS BLURRED OUT ALREADY -->
      <!-- <label
        class="text-uppercase work-sans label-text "
        v-if="!hasNHMIS && values.label == 'Num/Denom'"
      >
        {{ '' }}
      </label> -->
      <label
        :class="
          disableTarget
            ? 'text-uppercase work-sans label-text'
            : 'text-uppercase work-sans label-text disabled_alt'
        "
        v-if="values.label == 'Target'"
      >
        {{ values.label }}
      </label>
      <label
        :class="
          values.label === 'Num/Denom'
            ? 'text-uppercase work-sans label-text d-flex justify-content-center'
            : 'text-uppercase work-sans label-text d-flex align-items-center'
        "
        v-if="values.label !== 'Target' && values.label !== 'Year'"
      >
        {{ values.label }}
        <span
          v-if="values.key === 'indicator'"
          @click="openIndicatorExplanation()"
          class="indicator-info-icon ml-1"
          title="What does this indicator mean?"
        >&#9432;</span>
      </label>
      <label
        :class="
          values.label === 'Num/Denom'
            ? 'text-uppercase work-sans label-text d-flex justify-content-center'
            : 'text-uppercase work-sans label-text d-flex'
        "
        v-if="values.label === 'Year' && $store.getters.getSectionTitle !== 'Predictive Analysis'"
      >
        {{ values.label }}
      </label>

      <!-- <pre>{{ values }}</pre> -->

      <!-- ADVANCED ANALYTICS -->
      <!-- <pre>{{ values }}</pre> -->
      <selectWrapper
        v-if="values.type === 'dropdown' && values.key === 'indicator'"
        :id="label"
        :value="payload[values.key]"
        @input="updatePayload($event, values.key)"
        :options="getIndicatorList(values.options)"
        :multiSelectProps="values.dropdownProps"
        :NoDataLabel="values.label"
        :placeholder="'Select indicator'"
        :customFilter="customFilter"
      />
      <!-- MSDAT SUB-DASHBOARDS -->
      <selectWrapper
        v-if="values.type === 'dropdown' && values.key === 'compareBy'"
        :id="label"
        :value="payload[values.key]"
        @input="updatePayload($event, values.key)"
        :options="locationCheck(values.options)"
        :multiSelectProps="values.dropdownProps"
        :NoDataLabel="values.label"
        :placeholder="'Select a value'"
      />
      <selectWrapper
        v-if="values.type === 'dropdown' && values.key === 'datasource'"
        :id="label"
        :value="payload[values.key]"
        @input="updatePayload($event, values.key)"
        :options="locationCheck(values.options)"
        :multiSelectProps="values.dropdownProps"
        :NoDataLabel="values.label"
        :placeholder="'Select datasource'"
      />
      <selectWrapper
        v-if="values.type === 'dropdown' && values.key === 'location'"
        :id="label"
        :value="payload[values.key]"
        @input="updatePayload($event, values.key)"
        :options="locationCheck(values.options, 'location')"
        :multiSelectProps="values.dropdownProps"
        :NoDataLabel="values.label"
        :placeholder="'Select location'"
      />
      <small
        v-if="values.type === 'dropdown' && values.key === 'location' && isCheckingLocationAvailability"
        class="text-muted d-block cascade-loading-caption"
      >
        Checking availability…
      </small>

      <selectWrapper
        v-if="
          values.type === 'dropdown' &&
          values.key === 'year' &&
          $store.getters.getSectionTitle !== 'Predictive Analysis'
        "
        :id="label"
        :value="payload[values.key]"
        @input="updatePayload($event, values.key)"
        :options="locationCheck(values.options)"
        :multiSelectProps="values.dropdownProps"
        :NoDataLabel="values.label"
        :placeholder="'Select year'"
      />

      <selectWrapper
        v-if="values.type === 'dropdown' && values.key === 'visualization'"
        :id="label"
        :value="payload[values.key]"
        @input="updatePayload($event, values.key)"
        :options="locationCheck(values.options)"
        :multiSelectProps="values.dropdownProps"
        :NoDataLabel="values.label"
      />

      <!-- Policy Simulator -->
      <Generate
        v-if="values.type === 'generate'"
        :options="values.options"
        :value="payload[values.key]"
      ></Generate>

      <!-- history -->
      <History v-if="values.type === 'history'">Policy History</History>

      <!-- {{ showItem(values.options) }} -->
      <!-- </div> -->
      <!-- <div class="disabled_alt"> -->
      <div class="d-flex justify-content-center">
        <toggle v-if="values.type === 'toggle'" @change="updatePayload($event, values.key)" />
      </div>

      <div class="d-flex" v-if="values.type === 'checkbox'">
        <!-- National Target here -->
        <div :class="disableTarget ? 'd-flex ' : 'd-flex disabled_alt'">
          <BaseCheckbox
            :currentValue="payload.target.national"
            @input="updatePayload({ sdg: payload.target.sdg, national: $event }, 'target')"
          />
          <p class="check-label ml-1">National</p>
        </div>
        <!-- SDG Target here -->
        <div :class="disableTarget ? 'd-flex ml-3' : 'd-flex ml-3 disabled_alt'">
          <BaseCheckbox
            :currentValue="payload.target.sdg"
            @input="updatePayload({ sdg: $event, national: payload.target.national }, 'target')"
          />
          <p class="check-label ml-1">SDG</p>
        </div>
      </div>
      <div v-if="values.type === 'visualization'" class="btn-group d-flex work-sans" role="group">
        <button
          type="button"
          @click="updatePayload('zonal_map', values.key), (activeToggleButton = 'zonal_map')"
          class="btn btn-lg btn-outline-primary"
          :class="[activeToggleButton === 'zonal_map' ? 'active' : '']"
        >
          Zones Map
          <img
            :src="
              require(`../svg/${
                activeToggleButton === 'zonal_map' ? 'state_map_white' : 'zonal_map'
              }.svg`)
            "
            alt=""
            srcset=""
          />
        </button>
        <button
          type="button"
          @click="updatePayload('state_map', values.key), (activeToggleButton = 'state_map')"
          class="btn btn-lg btn-outline-primary"
          :class="[activeToggleButton === 'state_map' ? 'active' : '']"
        >
          State Map
          <img
            class="text-danger"
            :src="
              require(`../svg/${
                activeToggleButton === 'state_map' ? 'state_map_white' : 'state_map'
              }.svg`)
            "
            alt=""
            srcset=""
          />

          <!-- - {{ activeToggleButton === 'zonal_map' ? 'state_map_white' : 'zonal_map' }} -->
        </button>
        <button
          type="button"
          @click="updatePayload('line', values.key), (activeToggleButton = 'line')"
          class="btn btn-lg btn-outline-primary"
          :class="[activeToggleButton === 'line' ? 'active' : '']"
        >
          Line <b-icon icon="graph-up"></b-icon>
        </button>
        <button
          type="button"
          @click="updatePayload('column', values.key), (activeToggleButton = 'column')"
          class="btn btn-lg btn-outline-primary"
          :class="[activeToggleButton === 'column' ? 'active' : '']"
        >
          Column <b-icon icon="bar-chart-fill"></b-icon>
        </button>
      </div>
      <!-- <div v-if="values.key === 'indicator' && getSelectedSection === 'Indicator Overview'" class="prog-label">
  <p class="first-text">
    Program Area: {{ payload.indicator ? payload.indicator.program_area : '' }}
  </p>
  <p class="second-text">The program area will display for each indicator</p>
</div> -->
    </div>

    <!-- Voice Control Button -->
    <div v-if="isIndicatorOverviewPanel" class="col-auto d-flex align-items-start">
      <div @click="isVoiceModalVisible = true" class="voice-wrapper">
        <div class="d-flex align-items-center voice-item">
          <b-icon icon="mic-fill" class=""></b-icon>
          <span class="font-weight-bold">voice</span>
        </div>

        <span class="exp">(experimental)</span>
      </div>
    </div>

    <!-- Insight Brief Button -->
    <div class="col-auto d-flex align-items-start ml-2">
      <button
        type="button"
        @click="generateInsight"
        class="insight-action-btn"
        title="Generate Insight Brief"
      >
        <b-icon icon="journal-text"></b-icon>
        <span>Generate Insight Brief</span>
      </button>
    </div>

    <!-- Priority Signals Button -->
    <div class="col-auto d-flex align-items-start ml-2">
      <button
        type="button"
        @click="openPrioritySignals"
        class="insight-action-btn"
        title="View priority signals"
      >
        <b-icon icon="graph-up"></b-icon>
        <span>Priority Signals</span>
      </button>
    </div>

    <!-- (report builder capture is automatic demo button removed) -->

    <!-- Voice Control Modal Component -->
    <VoiceControlModal :show="isVoiceModalVisible" @close="isVoiceModalVisible = false" />
  </div>
</template>

<script>
// import ControlMixins from '@/components/ControlPanel/ControlMixins';
import { mapMutations, mapGetters } from 'vuex';
// eslint-disable-next-line import/no-unresolved
import BaseCheckbox from '@/components/ControlPanel/components/checkbox.vue';
// eslint-disable-next-line import/no-unresolved
import toggle from '@/components/ControlPanel/components/toggle-switch.vue';
import selectWrapper from './SelectDropdown.vue';
import Generate from '../components/generate.vue';
import VoiceControlModal from '../components/VoiceControl/voiceControlModal.vue';

export default {
  name: 'ControlPanel',
  data() {
    return {
      activeToggleButton: '',
      dashboardName: '',
      showVoiceControl: false,
      // using component data with 'Sub' addition to prevent prop mutations
      // (controlIndex & groupIndex)
      controlIndexSub: this.controlIndex,
      groupIndexSub: this.groupIndex,
      hasNHMIS: false,
      selectedSection: '',
      isVoiceModalVisible: false,
    };
  },
  components: {
    selectWrapper,
    BaseCheckbox,
    toggle,
    Generate,
    VoiceControlModal,
  },
  props: {
    setup: {
      type: Array,
      required: true,
    },
    indicatorList: {
      type: String,
      required: false,
      default: () => null,
    },
    groupIndex: {
      type: Number,
      default: () => null,
    },
    label: {
      type: String,
      default: () => null,
    },
    controlIndex: {
      type: Number,
      required: true,
    },
    defaultIndicator: {
      type: Object,
      required: false,
    },
    defaultDataSource: {
      type: Object,
      required: false,
    },
    defaultLocation: {
      type: Object,
      required: false,
    },
    defaultYear: {
      type: [Object, String],
      required: false,
    },
    updateValue: {
      type: Object,
      required: false,
    },
    updateKey: {
      type: String,
      required: false,
    },

    resetData: {
      type: Number,
      required: false,
    },
  },
  watch: {
    defaultDataSource(newValue) {
      this.payload.datasource = newValue;
    },
    payload: {
      handler(newValue) {
        this.$emit('data:options', newValue);
        this.saveNewActivity(newValue);
      },
      immediate: true,
      deep: true,
    },

    updateValue(newValue) {
      this.controlIndexSub = 0;
      this.groupIndexSub = null;
      this.updatePayload(newValue, 'datasource');
    },

    resetData: {
      handler() {
        this.controlIndexSub = 0;
        this.groupIndexSub = null;
        this.updatePayload(this.defaultDataSource, 'datasource');
      },
      immediate: true,
    },

    cascadeCacheKey: {
      handler(newKey) {
        if (!newKey) return;
        const [indicatorId, datasourceId] = newKey.split(':').map(Number);
        this.$store
          .dispatch('filterAvailability/fetchAvailableLocations', { indicatorId, datasourceId })
          .then((result) => {
            if (result && result.degraded && result.shouldWarn && this.$swal) {
              this.$swal({
                toast: true,
                position: 'bottom',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: 'warning',
                title: 'Filter availability check unavailable — some selections may return no data.',
              });
            }
          })
          .catch(() => {});
      },
      immediate: true,
    },
  },
  methods: {
    // eslint-disable-next-line consistent-return
    // eslint-disable-next-line operator-linebreak
    // eslint-disable-next-line camelcase

    ...mapMutations('MSDAT_STORE', ['SET_SELECTED_CONFIG']),
    /**
     * @description check if datasource dropdown has NHMIS-DHIS2
     * checks if the key is datasource then create a new array of datasource id
     * checks if the array has NHMIS-DHIS2 with id of 6
     */
    saveNewActivity(newValue) {
      const {
        indicator, datasource, location, year,
      } = newValue;
      // eslint-disable-next-line camelcase
      const ind = Array.isArray(indicator)
        ? // eslint-disable-next-line operator-linebreak
          // eslint-disable-next-line camelcase
          indicator[indicator.length - 1]?.short_name
        : // eslint-disable-next-line operator-linebreak
          // eslint-disable-next-line camelcase
          indicator?.short_name;

      // eslint-disable-next-line no-nested-ternary
      const dat = Array.isArray(datasource)
        ? datasource[datasource.length - 1]?.item
        : datasource.datasource
          ? datasource.datasource
          : datasource?.item;
      const loc = location?.name === 'Nigeria' ? 'National' : location?.name;
      if (ind && dat && this.getUser.id) {
        const activityObject = {
          id: `${this.getUser.id}${Date.now()}`,
          datetime: Date.now(),
          page: this.$route.params.name.split('_').slice(0, 2).join(' '),
          section: this.$store.state.MSDAT_STORE.controlConfig[this.controlIndex].label,
          parameters: `${ind}, ${dat}${year ? ` ${year}` : ''}${loc ? `, ${loc}` : ''}`,
        };
        const lastActivity = JSON.parse(localStorage.getItem('lastActivity') || '{}');
        const hold = (Date.now() - lastActivity.datetime || 0) >= 5000;
        const diff
          = lastActivity.page !== activityObject.page
          || lastActivity.section !== activityObject.section
          || lastActivity.parameters !== activityObject.parameters;
        if (hold && diff) {
          // send activity post request to backend
          // console.log('activity', activityObject);
        }
        localStorage.setItem('lastActivity', JSON.stringify(activityObject));
      }
    },
    // ...existing methods continue here
    locationCheck(options) {
      // I do not understand this logic, but it is used to filter out
      // the options in the dropdown based on the current route
      // if (
      //   // eslint-disable-next-line operator-linebreak
      //   this.$route.params.name === 'Disease_Surveillance' &&
      //   // eslint-disable-next-line operator-linebreak
      //   options !== null &&
      //   options.length === 38
      // ) {
      //   // const main = options.filter((s) => s.name === 'Nigeria');
      //   // console.log(main, 'Nigeria');
      //   return options.filter((s) => s.name === 'Nigeria');
      // }
      // am returning the options as is

      return options;
    },
    checkNHMISDHIS2() {
      this.setup.forEach((item) => {
        if (item.key === 'datasource') {
          const datasourceArr = item?.options?.map((el) => el.id);
          if (datasourceArr?.includes(6)) {
            this.hasNHMIS = true;
          } else {
            this.hasNHMIS = false;
          }
        }
      });
    },
    getIndicatorList(data) {
      // const { name } = this.$route.params;
      // if (name === 'Advanced_Analytics') {
      //   return data?.filter((item) => item.program_area === this.indicatorList);
      // }

      // console.log(this.$store.getters.getSectionTitle, 'XXXXX');

      const { name } = this.$route.params;
      if (
        name === 'Advanced_Analytics'
        && this.$store.getters.getSectionTitle === 'Multisource Inidcator Comparison'
      ) {
        return data?.filter((item) => item.program_area === this.indicatorList);
      }

      return data;

      // if (this.indicatorList !== '' || this.indicatorList !== null) {
      //   return data?.filter((item) => item.program_area === this.indicatorList);
      // }
    },
    updatePayload(value, key) {
      if (this.groupIndexSub != null) {
        // this is to take into consideration control panel that
        // are grouped example is Multi-source comparison section
        // debugger;
        this.$store.commit('MSDAT_STORE/SET_PAYLOAD', {
          controlIndex: this.controlIndexSub,
          groupIndex: this.groupIndexSub,
          key,
          value,
        });
      } else {
        this.$store.commit('MSDAT_STORE/SET_PAYLOAD', {
          controlIndex: this.controlIndexSub,
          key,
          value,
        });
      }

      if (key === 'indicator') {
        this.$store.commit('MSDAT_STORE/SET_SELECTED_CONFIG', {
          entity: 'indicator',
          payload: value,
        });
      }

      this.controlIndexSub = this.controlIndex;
      this.groupIndexSub = this.groupIndex;
      this.$emit('data:options', this.payload);
    },
    updateMultiIndicatorPayload(value) {
      this.$store.commit('MSDAT_STORE/SET_ALL_CONFIG_RESOURCE', {
        entity: 'indicator',
        value,
      });
      // this.controlIndexSub = this.controlIndex;
      // this.groupIndexSub = this.groupIndex;
      // this.$emit('data:options', this.payload);
    },
    updateMultiDatasourcePayload(value) {
      if (this.groupIndexSub != null) {
        // this is to take into consideration control panel that
        // are grouped example is Multi-source comparison section
        // debugger;
        this.$store.commit('MSDAT_STORE/SET_SELECTED_CONFIG', {
          entity: 'dataSource',
          payload: value,
        });

        this.$store.commit('MSDAT_STORE/SET_ALL_CONFIG_RESOURCE', {
          entity: 'datasource',
          value,
        });
      } else {
        this.$store.commit('MSDAT_STORE/SET_SELECTED_CONFIG', {
          entity: 'dataSource',
          payload: value,
        });
        this.$store.commit('MSDAT_STORE/SET_ALL_CONFIG_RESOURCE', {
          entity: 'datasource',
          value,
        });
      }
      // this.controlIndexSub = this.controlIndex;
      // this.groupIndexSub = this.groupIndex;
      // this.$emit('data:options', this.payload);
    },
    updateMultiPeriodPayload(value) {
      if (this.groupIndexSub != null) {
        // this is to take into consideration control panel that
        // are grouped example is Multi-source comparison section
        // debugger;
        this.$store.commit('MSDAT_STORE/SET_SELECTED_CONFIG', {
          entity: 'period',
          payload: value,
        });

        this.$store.commit('MSDAT_STORE/SET_ALL_CONFIG_RESOURCE', {
          entity: 'year',
          value,
        });
      } else {
        this.$store.commit('MSDAT_STORE/SET_SELECTED_CONFIG', {
          entity: 'period',
          payload: value,
        });
        this.$store.commit('MSDAT_STORE/SET_ALL_CONFIG_RESOURCE', {
          entity: 'year',
          value,
        });
      }
      // this.controlIndexSub = this.controlIndex;
      // this.groupIndexSub = this.groupIndex;
      // this.$emit('data:options', this.payload);
    },
    customFilter(option, search) {
      console.log('<<@>>');

      if (!search) return true;

      // if search starts with #
      if (search.startsWith('#')) {
        const tagSearch = search.slice(1); // remove #
        return option.tags.map((t) => String(t)).some((t) => t.includes(tagSearch));
      }

      // normal search
      return (
        option.full_name.toLowerCase().includes(search.toLowerCase())
        || option.short_name.toLowerCase().includes(search.toLowerCase())
      );
    },
    /* eslint-disable camelcase */
    generateInsight() {
      const indicator = this.payload.indicator || {};
      const location = this.payload.location || {};
      const datasource = this.payload.datasource || {};

      const payload = {
        indicator: indicator.full_name || 'All Indicators',
        indicatorId: indicator.id,
        location: location.name || 'Nigeria',
        locationId: location.id,
        period: this.payload.year || 'N/A',
        datasource: datasource.datasource || datasource.item || 'N/A',
        datasourceId: datasource.id,
      };
      this.$emit('generate-insight', payload);
    },
    openPrioritySignals() {
      const indicator = this.payload.indicator || {};
      const location = this.payload.location || {};
      const datasource = this.payload.datasource || {};
      const indicatorId = indicator.id || indicator.indicator_id || null;
      const locationId = location.id || location.location_id || null;
      const datasourceId = datasource.id || datasource.datasource_id || null;

      const payload = {
        indicator: indicator.full_name || indicator.name || 'All Indicators',
        indicatorId,
        location: location.name || location.location_name || 'Nigeria',
        locationId,
        period: this.payload.year || this.payload.period || 'N/A',
        datasource: datasource.datasource || datasource.item || datasource.name || 'N/A',
        datasourceId,
      };
      this.$emit('open-priority-signals', payload);
    },
    /* eslint-enable camelcase */
    openIndicatorExplanation() {
      const indicatorId = this.payload?.indicator?.id
        || this.payload?.indicator;
      if (!indicatorId) return;
      this.$root.$emit('open-indicator-explanation', indicatorId);
    },
  },
  computed: {
    ...mapGetters('AUTH_STORE', ['getUser']),
    ...mapGetters('MSDAT_STORE', ['getSelectedSection']),
    payload() {
      if (this.groupIndex != null) {
        // this is to take into consideration control panel that
        // are grouped example is Multi-source comparison section
        return this.$store.state.MSDAT_STORE.controlConfig[this.controlIndex].payload[
          this.groupIndex
        ];
      }
      return this.$store.state.MSDAT_STORE.controlConfig[this.controlIndex].payload;
    },
    disableTarget() {
      if (
        this.$route.path === '/dashboard/Health_Outcomes_and_Service_Coverage'
        || this.$route.path === '/dashboard/Health_Financing'
        || this.$route.path === '/dashboard/Health_Service_Access'
        || this.$route.path === '/dashboard/Demographics'
      ) {
        return true;
      }
      return false;
    },
    // Show voice controls only on the Indicator Overview control panel
    isIndicatorOverviewPanel() {
      try {
        const configLabel = this.$store.state.MSDAT_STORE.controlConfig[this.controlIndex]?.label;
        return (
          configLabel === 'Indicator Overview' || this.getSelectedSection === 'Indicator Overview'
        );
      } catch (e) {
        return this.getSelectedSection === 'Indicator Overview';
      }
    },
    cascadeDashboardNames() {
      return ['Demographics', 'Health_Facility', 'Health_Financing', 'Health_Workforce'];
    },
    isCascadeEligible() {
      if (this.groupIndex != null) return false;
      if (!this.cascadeDashboardNames.includes(this.$route.params.name)) return false;
      const configLabel = this.$store.state.MSDAT_STORE.controlConfig[this.controlIndex]?.label;
      if (configLabel !== 'Indicator Overview') return false;
      const ind = this.payload && this.payload.indicator;
      const ds = this.payload && this.payload.datasource;
      if (Array.isArray(ind) || Array.isArray(ds)) return false;
      if (!ind || typeof ind !== 'object' || !ds || typeof ds !== 'object') return false;
      return Array.isArray(this.setup) && this.setup.some((control) => control.key === 'location');
    },
    cascadeCacheKey() {
      if (!this.isCascadeEligible) return null;
      const indicatorId = this.payload && this.payload.indicator && this.payload.indicator.id;
      const datasourceId = this.payload && this.payload.datasource && this.payload.datasource.id;
      if (!indicatorId || !datasourceId) return null;
      return `${indicatorId}:${datasourceId}`;
    },
    isCheckingLocationAvailability() {
      if (!this.cascadeCacheKey) return false;
      const [indicatorId, datasourceId] = this.cascadeCacheKey.split(':').map(Number);
      return this.$store.getters['filterAvailability/isChecking'](indicatorId, datasourceId);
    },
    // Smart Cascade Filtering: `setup` with the location control's state
    // options tagged `$noSubNationalData` when the selected indicator +
    // data source has NO LGA-level (level 4) rows under that state. Nothing
    // is ever disabled -- the tag drives an informational "No LGA data
    // available" badge in SelectDropdown; every location stays selectable.
    //
    // This is a *computed* (cached by Vue, recomputed only when its reactive
    // deps change) rather than a template-called method -- returning a fresh
    // array identity on every render feeds the child SelectDropdown's deep
    // `options` watcher and wedges the panel in a re-render storm. When the
    // panel is not cascade-eligible, or availability is still unresolved /
    // degraded, the untouched `setup` reference is returned unchanged.
    computedSetup() {
      if (!Array.isArray(this.setup) || !this.isCascadeEligible) return this.setup;
      const indicatorId = this.payload.indicator.id;
      const datasourceId = this.payload.datasource.id;
      if (!indicatorId || !datasourceId) return this.setup;
      const locations = this.$store.getters['filterAvailability/getAvailableLocations'](
        indicatorId,
        datasourceId,
      );
      if (!Array.isArray(locations)) return this.setup;
      // State (level 3) IDs that have at least one LGA (level 4) row with data.
      const statesWithLgaData = new Set(
        locations
          .filter((l) => l && l.level === 4 && l.parent != null)
          .map((l) => l.parent),
      );
      return this.setup.map((control) => {
        if (!control || control.key !== 'location' || !Array.isArray(control.options)) {
          return control;
        }
        const options = control.options.map((option) => {
          if (!option || typeof option !== 'object') return option;
          // Only state-level options get the badge -- never Nigeria (id 1)
          // or zones. `level` on dropdown options matches the reference
          // table (3 = state); fall back to "not national" if absent.
          const isStateOption = option.id !== 1
            && (option.level == null || option.level >= 3);
          return {
            ...option,
            $noSubNationalData: isStateOption && !statesWithLgaData.has(option.id),
          };
        });
        return { ...control, options };
      });
    },
  },

  mounted() {
    const { name } = this.$route.params;
    this.dashboardName = name;
    const date = new Date();
    const getYear = date.getFullYear() + 1;

    // Resolve year setup by key instead of hard-coded index so dashboards with
    // different setup shapes don't crash on mount.
    const yearSetup = Array.isArray(this.setup)
      ? this.setup.find((item) => item && item.key === 'year')
      : null;
    const defaultYears = Array.isArray(yearSetup?.options) ? yearSetup.options : [];

    const newArr = [];
    defaultYears.forEach((el) => {
      if (el < getYear) {
        newArr.push(el);
        this.defaultYearDropdown = newArr;
      }
    });

    this.checkNHMISDHIS2();

    const initialIndicator = this.$store.state.MSDAT_STORE.selectedConfigurations.indicator
      || this.defaultIndicator;

    if (initialIndicator) {
      this.updatePayload(initialIndicator, 'indicator');
      this.updateMultiIndicatorPayload(initialIndicator);
    }

    if (this.defaultDataSource) {
      this.updatePayload(this.defaultDataSource, 'datasource');
      this.updateMultiDatasourcePayload(this.defaultDataSource);
    }

    if (this.defaultLocation) {
      this.updatePayload(this.defaultLocation, 'location');
    }

    if (this.defaultYear) {
      this.updatePayload(this.defaultYear, 'year');
      this.updateMultiPeriodPayload(this.defaultYear);
    }

    this.activeToggleButton = this.payload.visualization;
  },
};
</script>

<style lang="scss" scoped>
.label-text {
  padding-top: 6px;
  font-weight: bold;
  font-size: 14px;
}

.indicator-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #348481;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s, transform 0.2s;
  user-select: none;
}
.indicator-info-icon:hover {
  color: #d81b60;
  transform: scale(1.2);
}

.cascade-loading-caption {
  font-size: 11px;
  margin-top: 2px;
}

button {
  font-size: 12px;
  font-weight: bold;
}

.voice-btn-custom {
  --custom-color: #007d53;
  color: var(--custom-color);
  border-color: var(--custom-color);
  background-color: #fff; /* Set default background to white */
}

.voice-btn-custom:hover,
.voice-btn-custom:focus,
.voice-btn-custom:active,
.voice-btn-custom.active {
  color: #fff; /* White text on hover/active */
  background-color: var(--custom-color);
  border-color: var(--custom-color);
  box-shadow: 0 0 0 0.2rem rgba(0, 125, 83, 0.5); /* Optional: Adjust focus shadow color */
}

.voice-btn-custom:hover small {
  color: white;
}
// .prog-label {
//   display: flex;
//   position: absolute;
//   align-items: center;
//   background-color: #DFF3F3;
//   border:1px solid #D6D6D6;
//   margin-top: 12px;
//   margin-left: -8px;
//   left: 0;
//   right: 0;
//   font-weight: 400;
//   width: 100vw;
//   flex-direction: row;
//   justify-content: space-between;
//   z-index: 10;
//   padding: 1px 16px;
// }

// .first-text {
//   font-size: 14px;
//   font-weight: 500;
//   margin-bottom: 0;
//   color: #232323;
// }

// .second-text {
//   font-size: 13px;
//   margin-bottom: 0;
//   color: #656565;
//   padding-right: 32px;
// }

@media (max-width: 900px) {
  .prog-label {
    display: none;
  }
}

.voice-wrapper {
  border: 0.5px solid var(--custom-color);
  padding: 5px 10px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 0 0.1rem rgba(0, 125, 83, 0.5);
  cursor: pointer;
  margin-top: 10px;
  margin-right: 40px;
}

.voice-wrapper .exp {
  margin-top: -5px;
  font-size: 10px;
}

.voice-wrapper:hover {
  background-color: #007d53;
  border-color: #007d53;
  color: #fff;
}

.voice-wrapper:hover span,
.voice-wrapper:hover svg {
  color: #fff;
}

.voice-item span {
  font-size: 14px;
}

.voice-item svg {
  font-size: 14px;
}

.insight-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 6px 14px;
  border: 0.5px solid var(--custom-color);
  border-radius: 20px;
  background: #fff;
  color: var(--custom-color);
  box-shadow: 0 0 0 0.1rem rgba(0, 125, 83, 0.5);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.insight-action-btn:hover,
.insight-action-btn:focus {
  background-color: #007d53;
  border-color: #007d53;
  color: #fff;
  outline: none;
}

.insight-action-btn:hover span,
.insight-action-btn:focus span,
.insight-action-btn:hover svg,
.insight-action-btn:focus svg {
  color: #fff;
}

.insight-action-btn:active {
  background-color: #006344;
  border-color: #006344;
  color: #fff;
}

.insight-action-btn svg {
  font-size: 14px;
}
</style>
